import React, { useContext, useState } from 'react';
import { useStyletron } from 'baseui';
import * as yup from 'yup';

import { EMPTY_OBJECT, FormBuilder, AppContext, ModalContext, RenderConfig, Row, TextInput } from 'commons-ui';
import useActionService from '../../useService';
import { BUTTON_LABELS } from '../../constants';

const validationSchema = yup.object().shape({
	alternatePhoneNumber: yup
		.string()
		.matches(/^[6-9]\d{9}$/, 'Enter a valid 10 digit mobile number starting with 6-9')
		.required('Alternate Phone Number is required')
});

const FORM_FIELD_CONFIG = {
	alternatePhoneNumber: new RenderConfig()
		.setName('alternatePhoneNumber')
		.setLabel('Alternate Phone Number')
		.setRenderer(TextInput)
		.setRenderProps({ isEditable: { create: true, edit: true }, required: true })
};

const FORM_LAYOUT_CONFIG = [new Row('alternatePhoneNumber')];

interface IProps {
	handleForceUpdate: () => void;
}

const Content: React.FC<IProps> = ({ handleForceUpdate }) => {
	const [css] = useStyletron();
	const { showAlert } = useContext(AppContext);
	const { setModalConfig } = useContext(ModalContext);
	const { updateAlternatePhone } = useActionService();
	const [showLoader, setShowLoader] = useState<boolean>(false);

	const handleFormSubmit = async (formData: { alternatePhoneNumber: string }) => {
		setShowLoader(true);
		try {
			const result = await updateAlternatePhone({ alternatePhoneNumber: formData.alternatePhoneNumber });
			if (!result || result.data?.success === false) {
				showAlert('Failed to update alternate phone number.', { type: 'error' });
				setModalConfig({ isOpen: false });
				return;
			}
			showAlert('Alternate phone number updated.', { type: 'success' });
			handleForceUpdate();
			setModalConfig({ isOpen: false });
		} finally {
			setShowLoader(false);
		}
	};

	const handleFormCancel = () => setModalConfig({ isOpen: false });

	return (
		<div className={css({ width: '40vw' })}>
			<FormBuilder
				data={EMPTY_OBJECT}
				mode='create'
				showLoader={showLoader}
				setShowLoader={setShowLoader}
				handleFormSubmit={handleFormSubmit}
				handleFormCancel={handleFormCancel}
				fieldConfig={FORM_FIELD_CONFIG}
				layoutConfig={FORM_LAYOUT_CONFIG}
				validationSchema={validationSchema}
				buttonLabels={{ submitLabel: BUTTON_LABELS.AGREE, discardLabel: BUTTON_LABELS.DISAGREE }}
				hidePopUp
			/>
		</div>
	);
};

export default Content;
